import TimelineSidebar from '@/components/PartnerPortal/TimelineSidebarPartner';
import React from 'react';

const criteriaData = [
  {
    criteria: 'Certification',
    description: 'Must be a registered corporate',
  },
  {
    criteria: 'Business Size',
    description: 'Must be a major player in the industry in the given region.',
  },
  {
    criteria: 'Locations',
    description: 'Must have Anacle branded showrooms.',
  },
  {
    criteria: 'Volume',
    description:
      'Minimum sales order per country per year is SGD 200,000 or its equivalent.',
  },
  {
    criteria: 'Personnel',
    description:
      'Must appoint Anacle product managers and country sales consultants to champion Simplicity® solutions. \nMust achieve Silver Certified Professional Service Provider status within 12 months of signing Preferred VAR Agreement.',
  },
  {
    criteria: 'Support',
    description:
      'Must operate at least one functional Simplicity® service and technical support center.',
  },
  {
    criteria: 'Marketing',
    description:
      'Must promote and act as Anacle’s brand champion to enhance brand visibility across the country and in marketing\n initiatives to make Simplicity® the brand of choice for customers.',
  },
  {
    criteria: 'Capacity',
    description: 'Must demonstrate evidence of strong financial standing.',
  },
];

export default function Criteria() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5">
      <div className="col-span-1 mt-20 ml-11">
        <TimelineSidebar selectedIndex={2} />
      </div>
      <div className="col-span-4 mx-auto py-14">
        <h1 className="text-4xl mb-4 whitespace-pre-line leading-normal">
          {'Exclusive Value-Added Reseller\n Qualifying Criteria'}
        </h1>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm">
            <thead>
              <tr className="text-left text-[#BF984D] border-b border-gray-700">
                <th className="text-base font-medium">Criteria</th>
                <th className="w-3/4 text-base font-medium text-start">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {criteriaData.map((item, index) => (
                <tr
                  key={index}
                  className={`text-sm ${
                    index === criteriaData.length - 1
                      ? ''
                      : 'border-b border-gray-300'
                  }`}
                >
                  <td className="py-6 text-lg font-medium">{item.criteria}</td>
                  <td className="py-3 text-start tracking-wide whitespace-pre-line">
                    {item.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
